import { Calendar, Map, Target } from 'lucide-react';

export function PracticeLoadingRows({ label = 'Loading practice…' }: { label?: string }) {
    return <div role="status" aria-label={label} className="space-y-3">
        <span className="text-sm text-slate-400">{label}</span>
        {[0, 1, 2].map(row => <div key={row} aria-hidden="true" className="h-16 rounded-xl border border-slate-700/40 bg-slate-800/40 motion-safe:animate-pulse" />)}
    </div>;
}

// Shared by the route and the data loader, so neither leaves an empty page.
export function PracticeLoading({ error, onRetry }: { error?: string | null; onRetry?: () => void }) {
    return <div className="min-h-screen pt-6 pb-12 grid grid-cols-1 lg:grid-cols-7 gap-6 content-start" aria-busy={!error}>
        <div className="lg:col-span-4 flex flex-col gap-4">
            <section className="rounded-2xl border border-slate-700/50 bg-slate-900/40 p-8 min-h-44">
                <h2 className="flex items-center gap-4 text-3xl font-black text-white"><Map className="text-blue-400" />Tactical Roadmap</h2>
                <p className="mt-6 text-sm text-slate-400">Plan your team's progression, map priorities and milestones.</p>
            </section>
            <section className="rounded-2xl border border-slate-700/50 bg-slate-900/40 p-6">
                <h2 className="flex items-center gap-4 text-2xl font-black text-white mb-6"><Target className="text-emerald-500" />Opponent Preparation</h2>
                {error ? <div role="alert" className="text-red-400">
                    <p>{error}</p>
                    <button onClick={onRetry} className="mt-4 rounded-lg border border-slate-600 px-4 py-2 text-white">Try again</button>
                </div> : <PracticeLoadingRows label="Loading team preparation…" />}
            </section>
        </div>
        <section className="lg:col-span-3 space-y-4">
            <div className="flex gap-4 items-center rounded-xl border border-slate-700/50 bg-slate-800/50 p-3 text-sm font-bold">
                <Calendar className="text-emerald-400" size={16} /><span className="text-emerald-400">Upcoming</span><span className="text-slate-400">Past</span>
            </div>
            {!error && <PracticeLoadingRows />}
        </section>
    </div>;
}
